import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ViajesService } from './../../services/viajes.service'
import { Observable } from 'rxjs/Observable';
// Angular Fire
@Component({
    styleUrls: ['./viaje.operador.styl'],
	templateUrl: './viaje-vista-operador.component.html'
})

export class ViajeVistaOperadorComponent implements OnInit {

	constructor(
        private activatedRoute:ActivatedRoute,
        private viajesService: ViajesService
    ){}
    
    viajeObtenido:Observable<any>;
    idViaje:any;
    idConfirmacion:any;
    ngOnInit(){
        this.activatedRoute.params.forEach((params:Params) => {
            this.idViaje= params.idViaje;
            this.viajeObtenido=  this.viajesService.obtenerViajePorId(this.idViaje).valueChanges();
        })

    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/components/viaje-vista-operador/viaje-vista-operador.component.ts